interface HandleChoiceRoomProps {
    isChoiceRoom: boolean;
    setIsChoiceRoom: React.Dispatch<React.SetStateAction<boolean>>;
    setNewOnPrice: React.Dispatch<React.SetStateAction<number>>;
    setNewOffPrice: React.Dispatch<React.SetStateAction<number>>;
    price: {
        normal: number;
        discount: number;
    };
}

export const handleChoiceRoom = ({
    isChoiceRoom,
    setIsChoiceRoom,
    setNewOffPrice,
    setNewOnPrice,
    price,
}: HandleChoiceRoomProps) => {
    setIsChoiceRoom((prev) => !prev);

    if (isChoiceRoom) {
        setNewOnPrice(price.normal);
        setNewOffPrice(price.discount);
    }
};
